
import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useEnduserAuth } from "../../../contexts/EnduserAuthContext";

const PaymentSuccessPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { verifySession } = useEnduserAuth();
  const [isRefreshing, setIsRefreshing] = useState(true);
  const [countdown, setCountdown] = useState(4);

  const orderId = searchParams.get("order_id");

  useEffect(() => {
    const refreshAndRedirect = async () => {
      try {
        // רענון סטטוס המנוי
        await verifySession();
      } catch (error) {
        console.error("Error refreshing session:", error);
      } finally {
        setIsRefreshing(false);
      }
    };

    refreshAndRedirect();
  }, [verifySession]);

  // ספירה לאחור והעברה לדשבורד
  useEffect(() => {
    if (!isRefreshing && countdown > 0) {
      const timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
      return () => clearTimeout(timer);
    }

    if (countdown === 0) {
      navigate("/enduser/dashboard");
    }
  }, [isRefreshing, countdown, navigate]);

  const handleContinue = () => {
    navigate("/enduser/dashboard");
  };

  return (
    <div
      dir="rtl"
      className="min-h-screen bg-gradient-to-b from-green-50 to-white flex items-center justify-center p-4"
    >
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
        {/* אייקון הצלחה */}
        <div className="mb-6">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <span className="text-5xl">🎉</span>
          </div>
          <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto -mt-12 mr-12 border-4 border-white shadow-lg">
            <svg
              className="w-8 h-8 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={3}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
        </div>

        {/* כותרת */}
        <h1 className="text-2xl font-bold text-gray-800 mb-2">
          התשלום התקבל בהצלחה!
        </h1>

        <p className="text-gray-600 mb-6">
          המנוי שלך הופעל. תוכל להשתמש בכל המחשבונים במערכת.
        </p>

        {/* סטטוס */}
        {isRefreshing ? (
          <div className="flex items-center justify-center gap-2 text-gray-500 mb-6">
            <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-600"></div>
            <span>מעדכן את החשבון שלך...</span>
          </div>
        ) : (
          <p className="text-gray-500 mb-6">
            תועבר לדשבורד בעוד{" "}
            <span className="font-bold text-blue-600">{countdown}</span> שניות...
          </p>
        )}

        {/* Progress bar */}
        {!isRefreshing && (
          <div className="w-full bg-gray-200 rounded-full h-2 mb-6">
            <div
              className="bg-blue-600 h-2 rounded-full transition-all duration-1000"
              style={{ width: `${((4 - countdown) / 4) * 100}%` }}
            ></div>
          </div>
        )}

        {/* כפתור */}
        <button
          onClick={handleContinue}
          className="w-full bg-blue-600 text-white py-3 px-6 rounded-lg font-medium hover:bg-blue-700 transition-colors shadow-md"
        >
          המשך לדשבורד
        </button>

        {/* מספר הזמנה (אופציונלי) */}
        {orderId && (
          <p className="text-xs text-gray-400 mt-4">מספר הזמנה: {orderId}</p>
        )}
      </div>
    </div>
  );
};

export default PaymentSuccessPage;